// Sphere labels are chosen per-sphere by contrast against whatever fill is
// currently active. This lives on the client, not in a database column,
// because the Queen/King toggle changes the fill at runtime.

export const INK = "#0E1116";
export const PAPER = "#FFFFFF";

function channels(hex) {
  const value = String(hex).trim().replace(/^#/, "");
  const full =
    value.length === 3
      ? value.split("").map((c) => c + c).join("")
      : value;
  if (!/^[0-9a-f]{6}$/i.test(full)) return null;
  return [0, 2, 4].map((i) => parseInt(full.slice(i, i + 2), 16));
}

// WCAG 2.x relative luminance.
export function relativeLuminance(hex) {
  const rgb = channels(hex);
  if (!rgb) return 0;
  const [r, g, b] = rgb.map((c) => {
    const s = c / 255;
    return s <= 0.03928 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4);
  });
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

// WCAG 2.x contrast ratio, 1..21.
export function contrastRatio(a, b) {
  const la = relativeLuminance(a);
  const lb = relativeLuminance(b);
  const [hi, lo] = la >= lb ? [la, lb] : [lb, la];
  return (hi + 0.05) / (lo + 0.05);
}

// Whichever of ink/paper reads better on this fill.
//
// Note this deliberately differs from tree-reference.svg on Netzach (#009B5A):
// the reference uses white at 3.60:1, which fails WCAG AA for text this size.
// Max-contrast picks dark ink at 5.26:1. Do not "fix" this back.
export function inkFor(background) {
  return contrastRatio(background, INK) >= contrastRatio(background, PAPER)
    ? INK
    : PAPER;
}

// A numeral centred on Malkuth sits across all four quadrant colors at once, so
// no single choice can win outright. Take the one with the best worst-case
// contrast and let the halo carry the rest.
export function inkForMany(backgrounds) {
  if (!backgrounds || backgrounds.length === 0) return INK;
  const worst = (candidate) =>
    Math.min(...backgrounds.map((bg) => contrastRatio(bg, candidate)));
  return worst(INK) >= worst(PAPER) ? INK : PAPER;
}

export function haloFor(ink) {
  return ink === INK ? PAPER : INK;
}
